import HelpTextsPageView from "./HelpTextsPageView";

function HelpTextsPage() {
  return <HelpTextsPageView />;
}

export default HelpTextsPage;
